import { mentionText } from "./mentions";
export type ReviewDraft = {
  mentions: string[];
  action?: { title: string; assignee: string | null; due: string | null };
};
export type ReviewEvent = {
  mentionOccurrences?: { id: string; user: string }[];
  target?: {
    kind: "text";
    id: string;
    occurrences: { id: string; user: string }[];
  };
  id: string;
  board: string;
  comment: string;
  signature?: string;
  thread: string;
  actor: string;
  text: string;
  mentions: string[];
  replies: string[];
  action?: ReviewDraft["action"];
  /** An agent's reply to the member who called it; only that member is told. */
  agent?: { caller: string; number: number };
  at: number;
};
export const plainText = mentionText;
export function reviewDraft(value: unknown): ReviewDraft {
  if (value === undefined) return { mentions: [] };
  if (!value || typeof value !== "object")
    throw new Error("Invalid review details.");
  const r = value as Record<string, unknown>;
  if (
    !Array.isArray(r.mentions) ||
    r.mentions.length > 20 ||
    r.mentions.some((id) => typeof id !== "string" || id.length > 128)
  )
    throw new Error("Choose up to 20 project members.");
  const mentions = [...new Set(r.mentions as string[])];
  if (!r.action) return { mentions };
  const a = r.action as Record<string, unknown>;
  if (
    typeof a.title !== "string" ||
    !a.title.trim() ||
    a.title.length > 300 ||
    !(a.assignee === null || typeof a.assignee === "string") ||
    !(
      a.due === null ||
      (typeof a.due === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(a.due) &&
        Number.isFinite(Date.parse(a.due)) &&
        new Date(a.due).toISOString().slice(0, 10) === a.due)
    )
  )
    throw new Error("Enter an action description and valid optional due date.");
  return {
    mentions,
    action: {
      title: a.title.trim(),
      assignee: a.assignee as string | null,
      due: a.due as string | null,
    },
  };
}
export type ActionItem = {
  id: string;
  board_id: string;
  thread_id: string;
  title: string;
  assignee_id: string | null;
  due_date: string | null;
  done: number;
  created_by: string;
  updated_at: number;
  version: number;
};
export type InboxItem = {
  source_occurrences?: string | null;
  source_comment_id?: string | null;
  source_signature?: string | null;
  id: string;
  recipient_id?: string;
  board_id: string;
  actor: string;
  excerpt: string;
  /** mention, reply, assignment, or agent:<n> for an agent's reply to its caller. */
  kind: string;
  project: string;
  updated_at: number;
  read_at: number | null;
  action_id: string | null;
} & (
  | { target_kind: "text"; target_id: string; thread_id: null }
  | { target_kind?: "discussion"; target_id?: null; thread_id: string }
);
